export default "__VITE_ASSET__CXDSnUAR__"